import {AfterContentChecked, Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';

@Component({
  selector: 'app-span3dot',
  templateUrl: './span3dot.component.html',
  styleUrls: ['./span3dot.component.scss']
})
export class Span3dotComponent implements OnInit, AfterContentChecked, OnChanges {
  @Input() text: string;
  @Input() maxWidth: number;
  displayText: string;
  constructor(private el: ElementRef) { }

  ngOnInit(): void {
    this.displayText = this.text;
  }

  createDisplayText() {
    const nel = this.el.nativeElement;
    if (nel.offsetWidth > this.maxWidth) {
      const maxLength = Math.floor(this.text.length * this.maxWidth / nel.offsetWidth);
      if (maxLength > 12) {
        this.displayText = this.text.slice(0, maxLength - 12) + '[...]' + this.text.slice(this.text.length - 4);
      }
    }
  }

  ngAfterContentChecked() {
    this.createDisplayText();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('text' in changes) {
      if (changes.text.previousValue !== undefined) {
        if (changes.text.previousValue !== changes.text.currentValue) {
          this.displayText = changes.text.currentValue;
          this.createDisplayText();
        }
      }
    }
  }

}
